import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { ErrorMessage } from './ErrorMessage';
import { FormDivider } from './FormDivider';
import { SocialLoginButtons } from './SocialLoginButtons';

interface AuthFormLayoutProps {
  children: ReactNode;
  onGithubLogin: () => void;
  onGoogleLogin: () => void;
  isLoading: boolean;
  generalError?: string;
  showSocialLogin?: boolean;
  dividerText?: string;
  googleText?: string;
}

export const AuthFormLayout = ({
  children,
  onGithubLogin,
  onGoogleLogin,
  isLoading,
  generalError,
  showSocialLogin = true,
  dividerText,
  googleText,
}: AuthFormLayoutProps) => {
  const { t } = useTranslation();
  return (
    <>
      {showSocialLogin && (
        <>
          <SocialLoginButtons
            onGithubLogin={onGithubLogin}
            onGoogleLogin={onGoogleLogin}
            isLoading={isLoading}
            googleText={googleText}
          />
          <FormDivider text={dividerText || t('components.authForm.or')} />
        </>
      )}

      <ErrorMessage error={generalError} />

      {children}
    </>
  );
};